import { render, staticRenderFns } from "./wtriage.vue?vue&type=template&id=4ee2f21f"
import script from "./wtriage.vue?vue&type=script&lang=js"
export * from "./wtriage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports